import { render } from "./NoticeBox.vue?vue&type=template&id=b6a7cd9a&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&lang=js"
export * from "./NoticeBox.vue?vue&type=script&lang=js"

import "./NoticeBox.vue?vue&type=style&index=0&id=b6a7cd9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a7cd9a"]])

export default __exports__